export default __webpack_public_path__ + "static/media/04-1.02c7474e.png";